import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

const ProtocoloRoute = lazyRouteComponent(
  () => import('@/features/protocolo/Protocolo'),
  'Protocolo'
)

export const Route = createFileRoute('/protocolo')({
  component: ProtocoloRoute,
})
